// In-memory pub/sub bus for iPad live-events.
//
// Fed by `useIpadKillWatcher` (which owns the single iPad WebSocket
// connection). Any guest page that wants to react to server-side
// updates — roster changes, booking updates, cabin edits — calls
// `useIpadLive(handler)` and gets a callback for every non-kick
// message that arrives on the socket. Kick messages are handled by
// the watcher itself and never surface here.
//
// Also exposes a REST-poll fallback trigger — `notifySafetyTick()` —
// so the same subscribers can be reused for periodic refresh without
// duplicating the setInterval logic in every page.
const listeners = new Set();

export function publish(ev) {
  for (const fn of listeners) {
    try { fn(ev); } catch (e) { /* one bad listener shouldn't kill the others */ }
  }
}

export function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
